<template><section><h1>loading 加载中</h1>
<p>是一个指令。指令值为Boolean类型，用来控制是否显示loading。</p>
<h2 id="dai-ma-yan-shi"><a class="header-anchor" href="#dai-ma-yan-shi">¶</a> 代码演示</h2>

<h3 id="ji-chu-ying-yong"><a class="header-anchor" href="#ji-chu-ying-yong">¶</a> 基础应用</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;\n&lt;div style=\&quot;border: 1px solid #ccc;\&quot; v-loading=\&quot;true\&quot;&gt;\n    Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate asperiores tempora qui repellat iste, corrupti fugiat, voluptatem voluptatum suscipit odio inventore? Inventore recusandae deleniti quasi molestias amet laborum reprehenderit perspiciatis!\n&lt;/div&gt;\n\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source">
<div style="border: 1px solid #ccc;" v-loading="true">
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate asperiores tempora qui repellat iste, corrupti fugiat, voluptatem voluptatum suscipit odio inventore? Inventore recusandae deleniti quasi molestias amet laborum reprehenderit perspiciatis!
</div>

</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"border: 1px solid #ccc;"</span> <span class="hljs-attr">v-loading</span>=<span class="hljs-string">"true"</span>&gt;</span>
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate asperiores tempora qui repellat iste, corrupti fugiat, voluptatem voluptatum suscipit odio inventore? Inventore recusandae deleniti quasi molestias amet laborum reprehenderit perspiciatis!
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3 id="ke-gen-sui-nei-rong-da-xiao-zi-dong-diao-jie"><a class="header-anchor" href="#ke-gen-sui-nei-rong-da-xiao-zi-dong-diao-jie">¶</a> 可跟随内容大小自动调节</h3>
<p>可以改变文字大小，头像大小，设置文本头像的背景颜色以及显示文本头像的前几个字符</p>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;div class=\&quot;loading-demo\&quot; :style=\&quot;{height: height}\&quot; v-loading=\&quot;loading1\&quot;&gt;&lt;/div&gt;\n\n\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                loading1: false,\n                height: '100px'\n            }\n        },\n        mounted () {\n            setTimeout(() =&gt; {\n                this.height = '200px';\n            }, 3000);\n        }\n    }\n&quot;,&quot;style&quot;:&quot;\n    .loading-demo {\n        width: 100px;\n        border: 1px solid #ccc\n    }\n&quot;}">
        <div class="source" slot="source"><div class="loading-demo" :style="{height: height}" v-loading="loading1"></div>


</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"loading-demo"</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">"{height: height}"</span> <span class="hljs-attr">v-loading</span>=<span class="hljs-string">"loading1"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">style</span>&gt;</span><span class="css">
    <span class="hljs-selector-class">.loading-demo</span> {
        <span class="hljs-attribute">width</span>: <span class="hljs-number">100px</span>;
        <span class="hljs-attribute">border</span>: <span class="hljs-number">1px</span> solid <span class="hljs-number">#ccc</span>
    }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">loading1</span>: <span class="hljs-literal">false</span>,
                <span class="hljs-attr">height</span>: <span class="hljs-string">'100px'</span>
            }
        },
        mounted () {
            setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
                <span class="hljs-keyword">this</span>.height = <span class="hljs-string">'200px'</span>;
            }, <span class="hljs-number">3000</span>);
        }
    }
&lt;<span class="hljs-regexp">/script&gt;  
</span></code></pre>
</div></demo-block>
</section></template>
<style>
    .loading-demo {
        width: 100px;
        border: 1px solid #ccc
    }
</style>
<script>
    export default {
        data () {
            return {
                loading1: false,
                height: '100px'
            }
        },
        mounted () {
            setTimeout(() => {
                this.loading1 = true;
                this.height = '200px';
            }, 3000);
        }
    }
</script>